import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {ConstructsOverviewRepository} from '../repositories/constructs-overview.repository';

@Injectable()
export class ConstructsOverviewService {

  constructor(private overviewRepo: ConstructsOverviewRepository) { }

  public getAllConstructs(light: boolean): Observable<Array<Construct>> {
    return this.overviewRepo.getAllConstructs(light);
  }

  public getConstructById(id: number): Observable<Construct> {
    return this.overviewRepo.getConstructById(id);
  }

  public deleteDialog(id: number): Observable<Response> {
    return this.overviewRepo.deleteConstruct(id);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-overview/services/constructs-overview.service.ts